// A4: 1123px tall, 40px top/bottom padding, plus an 8px rounding allowance.
export const PAGE_CONTENT_HEIGHT = 1035;
export function planPages(blocks, heightLimit = PAGE_CONTENT_HEIGHT) {
  const pages=[];let page=[],height=0;let oversized=false;
  const flush=()=>{if(page.length)pages.push(page);page=[];height=0;};
  for(const block of blocks){
    const size=Number.isFinite(block.height)&&block.height>0?block.height:24;
    if(size>heightLimit+0.5)oversized=true;
    if((block.startAnswerKey||height+size>heightLimit)&&page.length)flush();
    page.push(block);height+=size;
  }
  flush();return {pages,oversized};
}
// Validate the measured editor pages again before rasterising them. This covers
// saved/legacy content and font changes even if pagination has not signalled yet.
export function hasPageOverflow(root){
  return [...root.querySelectorAll('.page')].some(page=>{
    const body=page.querySelector('.body');if(!body)return false;
    const box=page.getBoundingClientRect();const scale=page.offsetHeight?box.height/page.offsetHeight:1;
    if(!box.height||!scale)return false;
    const padding=parseFloat(getComputedStyle(page).paddingBottom)||0;
    const bottom=box.bottom-padding*scale;
    return body.scrollWidth>body.clientWidth+2||[...body.children].some(child=>child.getBoundingClientRect().bottom>bottom+scale*2);
  });
}
